import Alpine from "alpinejs";
import gsap from "gsap";

export const interviewArchiveAnimation = () => {
  Alpine.data("interviewArchiveAnimation", () => ({
    timeline: null as gsap.core.Timeline | null,
    init() {
      const root = this.$root as HTMLElement;
      const chars = Array.from(
        root.querySelectorAll(".js-interview-archive-char"),
      ) as HTMLElement[];
      const items = Array.from(
        root.querySelectorAll(".js-interview-archive-item"),
      ) as HTMLElement[];
      const jaLabel = this.$refs.jaLabel as HTMLElement | null;

      if (chars.length === 0 && items.length === 0 && !jaLabel) return;

      gsap.set(chars, { autoAlpha: 0, x: 16 });
      gsap.set(items, { autoAlpha: 0 });
      gsap.set(jaLabel, { autoAlpha: 0 });

      const tl = gsap.timeline();

      tl.to(jaLabel, {
        autoAlpha: 1,
        duration: 0.8,
        ease: "power2.out",
      })
        .to(
          chars,
          {
            x: 0,
            autoAlpha: 1,
            duration: 0.6,
            stagger: 0.05,
            ease: "power2.out",
          },
          0,
        )
        .to(
          items,
          {
            autoAlpha: 1,
            duration: 1.0,
            stagger: 0.1,
            ease: "power2.out",
          },
          "-=0.7",
        );

      this.timeline = tl;
    },
    destroy() {
      this.timeline?.kill();
      this.timeline = null;
    },
  }));
};
